import { State } from './reducers';
import { PropertyOrigin, CustomerOrigin } from '@api/v1';

const { Casavi, AccountCreation } = CustomerOrigin;

export const getRelayCustomers = (state: State) => ({
	customers: state.customers.list?.data?.filter((customer) => {
		if (customer.origin === Casavi || customer.origin === AccountCreation) {
			return false;
		}
		return true;
	})
});

export const getProperties = (state: State) => ({
	properties: state.properties.list?.data?.filter(
		(property) => property.origin !== PropertyOrigin.AccountCreation
	)
});
